// import React, {memo} from "react";
import { useState, useEffect } from "react";
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useRef } from "react";

import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";
import { Modal, Radio, Button } from 'antd';
import UserAlerts from "../../components/UserAlerts";

const ApplicationReviewOld = ({application, isModalOpen, setIsModalOpen}) => {

    const [error, setError] = useState('');
    const errorRef = useRef(null);

    // const params = useParams()
    const queryClient = useQueryClient();

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    const {fetchData, data, response}  = useAxios();
    // const { data:customerData, fetchData:fetchCustomerData}  = useAxios();   



    const client = localStorage.getItem('clientID');
    const user = localStorage.getItem('userID');

    const [approvedAmount, setApprovedAmount] = useState(application?application.amount:"");
    const [term, setTerm] = useState(application?application.term:""); 
    const [interestRate, setInterestRate] = useState("");
    const [loanDecision, setLoanDecision] = useState("10");
    const [memo, setMemo] = useState("");

    const navigate = useNavigate();

    const mutation = useMutation({
        mutationFn: (applicationData) => {
            console.log(application)
            return authAxios.patch(`/loans/loan-applications/${application.id}/approve/`, applicationData);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(['applications']);
            queryClient.refetchQueries(['applications']);
            setIsModalOpen(false);
            navigate('/dashboard/applications/');
        },
      })


    useEffect(() => {
        if (application){
            setApprovedAmount(application.amount)
            setTerm(application.term)
            setInterestRate(application.interest_rate*100+"")
        }
    }, [application]);


    const handleSubmit = (e) => {
        e.preventDefault();

        const amount = parseFloat(approvedAmount.replace(/,/g, ''));
        const interest_rate = parseFloat(interestRate.replace(/,/g, '')) / 100;

        const applicationData = { client, amount, term, interest_rate, memo, user };
        console.log(applicationData)
        mutation.mutate(applicationData)
    }



    return(
        <>
        {isModalOpen && 
            <Modal 
                className="dashboard-modal" 
                title="Loan Application Review" 
                visible={isModalOpen} 
                open={isModalOpen} 
                // onOk={handleSubmit} 
                onCancel={handleCancel}
                // confirmLoading={mutation.isLoading || mutationManagementFee.isLoading}
                footer={[
                  <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                  <Button key="submit" type="primary" loading={mutation.isLoading} onClick={handleSubmit}>
                    Submit
                  </Button>
                ]}
            >
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <Radio.Group 
                            defaultValue={loanDecision} 
                            // onChange={handleCustomerType} 
                            onChange={(e) => setLoanDecision(e.target.value)}
                            className="custom-input"
                        >
                            <Radio.Button  value={10}>Approve</Radio.Button>
                            <Radio.Button value={20}>Decline</Radio.Button>
                        </Radio.Group>

                        <TextField className="custom-input"
                            value={application?application.customer_name:""}
                            label="Name" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />

                        <TextField className="custom-input"
                            value={application?application.product_name:""}
                            label="Product" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />
                        <div style={{display: 'flex', gap: '10px'}}>
                            <NumberFormat   
                                value={application?application.amount:""}
                                className="custom-input"
                                fullWidth
                                label="Loan Amount" 
                                variant="outlined" 
                                customInput={TextField}
                                decimalScale={0}
                                fixedDecimalScale
                                decimalSeparator="."
                                isNumericString
                                thousandSeparator={true} 
                                disabled
                            />
                            <TextField className="custom-input"
                                value={application?application.term+""+application.term_unit_name:""}
                                label="Term" 
                                variant="outlined" 
                                fullWidth
                                disabled
                            />
                        </div>
              
                        {loanDecision===10 &&
                        <>     
                            <div style={{display: 'flex', gap: '10px'}}>
                                <NumberFormat   
                                    value={approvedAmount}
                                    onChange={(e) => setApprovedAmount(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Approved Amount" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    decimalScale={0}
                                    fixedDecimalScale
                                    decimalSeparator="."
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 
                                />

                                <NumberFormat   
                                    value={term}
                                    onChange={(e) => setTerm(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Approved Term" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 

                                />
                                <NumberFormat   
                                    value={interestRate}
                                    onChange={(e) => setInterestRate(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Interest Rate" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix="%"
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 

                                />
                       
                            </div>
                        </>
                        }

                        {loanDecision===20 &&
                        <>
                   
                            <TextField className="custom-input"
                                onChange={(e) => {
                                    setMemo(e.target.value)
                                }}
                                label="Reason"
                                variant="outlined"
                                multiline
                                rows={2}
                                fullWidth
                            />
                        </>
                        }

                    </form>
                </div>
            </Modal>
        }
        </>

    )

}

export default ApplicationReviewOld;

